import React from 'react';
import "./resume.css";

const Resume = () => {
    return (
        <section className="resume container section" id="resume">
            <h2 className="section__title"></h2>

            <div className="resume__container grid">
                <div className="timeline grid"></div>
            </div>
        </section>
    )
}
export default Resume